import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { AuthContext, I18nService, MenuControlService, VideoCallOverlayService } from '@heda/core-hospital-ui';
import { Location } from '@angular/common';
import { environment } from 'environments/environment';
import { ThemeService } from '@heda/core-hospital-ui/theme.service';

@Component({
  selector: 'hw-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent {
  public envLabel = environment.envLabel;

  public drawerOpen: boolean = false;
  public pinned: boolean = false;
  public sidebarState: any = {
    content: this.location.path() === '' ? 'user-menu' : null,
    width: 390,
  };
  public initialized: boolean = false;
  public selectedItemId: string;
  public mode: string = 'full';
  public lang: string = environment.defaultLang;

  constructor(
    public i18nService: I18nService,
    private location: Location,
    translateService: TranslateService,
    menuControlService: MenuControlService,
    public authContext: AuthContext,
    public videoCallService: VideoCallOverlayService,
    themeService: ThemeService
  ) {
    this.parseParams();
    themeService.reinit();
    const lang = localStorage.getItem('lang') || this.lang;
    translateService.setDefaultLang('en');
    translateService.use(lang).subscribe(
      () => (this.initialized = true),
      () => (this.initialized = true)
    );
    moment.locale(lang);

    menuControlService.onMenuSelect(() => {
      if (!this.pinned) {
        this.sidebarState.content = null;
      }
    });
  }

  private parseParams(): void {
    const queryParams = window.location.href.split('?')[1];
    if (queryParams) {
      const paramsSplitted = queryParams.split('&');
      const modeParam = paramsSplitted.find((param) => param.startsWith('mode='));
      if (modeParam && modeParam.length > 5) {
        this.mode = modeParam.substring(modeParam.indexOf('mode=') + 5, modeParam.length);
      }

      const langParam = paramsSplitted.find((param) => param.startsWith('lang='));
      if (langParam && langParam.length > 5) {
        this.lang = langParam.substring(langParam.indexOf('lang=') + 5, langParam.length);
        localStorage.setItem('lang', this.lang);
      }
    }
  }

  public selectItem($event: MouseEvent): void {
    const ct: Element = <Element>$event.currentTarget;
    this.selectedItemId = ct.id;
    switch (this.selectedItemId) {
      case 'navigation':
        this.toggleSidebarContent('navigation');
        break;
      case 'search':
        this.toggleDrawer();
        break;
      case 'user-menu':
        this.toggleSidebarContent('user-menu');
        break;
      case 'account-settings':
        this.toggleSidebarContent('account-settings');
        break;
    }
  }

  public pinMenu($event: boolean): void {
    this.pinned = $event;
  }

  public toggleSidebarContent(content: string): string {
    this.drawerOpen = false;
    if (this.sidebarState.content === content) {
      return (this.sidebarState.content = this.pinned ? content : null);
    }
    return (this.sidebarState.content = content);
  }

  public toggleDrawer(): void {
    this.drawerOpen = !this.drawerOpen;
    if (this.drawerOpen) {
      this.sidebarState.content = null;
    }
  }

  public initials(name: string): string {
    return !name
      ? ''
      : name
          .split(/, | /)
          .map((n) => n.substring(0, 1).toUpperCase())
          .join('');
  }

  public bugDebug(): void {
    const host = window.location.host;
    const path = window.location.pathname;
    if (host.startsWith('localhost')) {
      window.open('https://dev.heda.ee/web' + path);
    } else {
      const url = 'http://localhost:4200' + path.replace('/web/', '/');
      window.open(url, '_blank');
    }
  }
}
